import styled from "styled-components";

export const SliderContainer = styled.div`
  width: ${({ isView, isPreview }) => (isView || isPreview ? "100%" : "80%")};
  height: 480px;
  border-radius: ${({ borderRadius = 6 }) => `${borderRadius}px`};
  user-select: none;
  overflow: hidden;
  position: relative;
`;

export const SliderControlsContainer = styled.div`
  position: absolute;
  inset: 0;
  place-content: center;
  z-index: 10;
  pointer-events: none;
`;

export const SliderArrowsGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-inline: 14px;
  box-sizing: border-box;
  pointer-events: auto;
`;

export const SliderArrowContainer = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 9999px;
  background-color: rgba(0, 0, 0, 0.5);
  display: grid;
  place-content: center;
  cursor: pointer;
`;

export const SliderImagesContainer = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  height: 100%;
  transform: ${({ position }) => `translateX(-${position * 100}%)`};
  position: relative;
`;

export const SliderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  flex-shrink: 0;
  cursor: ${({ showPointer = false }) => (showPointer ? "pointer" : "default")};
`;

export const SliderImageContentContainer = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
`;

export const SliderImageContent = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  background-color: white;
  border-radius: 14px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  text-align: ${({ textAlign }) => textAlign};
`;

export const SliderImageHeading = styled.h1`
  margin: 0;
  color: #121212;
  font-size: 17px;
`;

export const SliderImageParagraph = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
`;
